module.exports = __webpack_public_path__ + "img/attack.1b410915.png";